import React from "react";

const CotizacionFilters = ({ filters, onChange }) => {
	const handleChange = (event) => {
		const { name, value } = event.target;
		onChange({ ...filters, [name]: value });
	};

	const fieldStyle = { marginBottom: "8px" };

	return (
		<div className="grid-x grid-margin-x" style={{ marginBottom: "16px" }}>
			<div className="cell small-12 medium-4 large-2" style={fieldStyle}>
				<label>
					Número
					<input
						type="text"
						name="number"
						value={filters.number}
						onChange={handleChange}
						placeholder="COT-..."
					/>
				</label>
			</div>
			<div className="cell small-12 medium-4 large-2" style={fieldStyle}>
				<label>
					Cliente
					<input
						type="text"
						name="cliente"
						value={filters.cliente}
						onChange={handleChange}
						placeholder="Nombre"
					/>
				</label>
			</div>
			<div className="cell small-12 medium-4 large-2" style={fieldStyle}>
				<label>
					RUT
					<input
						type="text"
						name="rut"
						value={filters.rut}
						onChange={handleChange}
						placeholder="12.345.678-9"
					/>
				</label>
			</div>
			<div className="cell small-12 medium-4 large-2" style={fieldStyle}>
				<label>
					Empresa emisora
					<input
						type="text"
						name="empresa"
						value={filters.empresa}
						onChange={handleChange}
						placeholder="DeNegocios"
					/>
				</label>
			</div>
			<div className="cell small-12 medium-4 large-2" style={fieldStyle}>
				<label>
					Fecha
					<input
						type="date"
						name="fecha"
						value={filters.fecha}
						onChange={handleChange}
					/>
				</label>
			</div>
			<div className="cell small-12 medium-4 large-2" style={fieldStyle}>
				<label>
					Estado
					<select name="status" value={filters.status} onChange={handleChange}>
						<option value="">Todos</option>
						<option value="borrador">Borrador</option>
						<option value="emitida">Emitida</option>
						<option value="anulada">Anulada</option>
					</select>
				</label>
			</div>
		</div>
	);
};

export default CotizacionFilters;
